
const digest = '5731644a6b3888d5b8a2d191c659017b822f8bf992d251939dbd179a673f9e1f';
const classes = {"wrapper":"_wrapper_1hjcv_1","title":"_title_1hjcv_9"};
const css = `._wrapper_1hjcv_1 {
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  font-family: Rubik, sans-serif;
  height: 100%;
  padding: 24px;
  overflow-y: auto;
}
._wrapper_1hjcv_1 ._title_1hjcv_9 {
  font-weight: 600;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  